module.exports = require('./helpers/bundle-url').getBundleURL('luNwF') + "logo-dark.aa58a0ab.svg";